import pipeline from "@/api/pipeline";
import build from "@/api/build";
import base from "@/api/base";
import setting from "@/api/setting";
import meeting from "@/api/meeting";
import user from "@/api/user";

export default {
    base,
    pipeline,
    build,
    setting,
    user,
    meeting
}